export async function montarQueryParams(planosSelecionados,cidadeSelecionada,estadoSelecionado) {
    const arrayQueryParams = []
    if (planosSelecionados[0] !== "Todos Planos"){
      const plano = `plano=${planosSelecionados.join('|')}`
      arrayQueryParams.push(plano)
  }
  //Todas Cidades
  if (Array.isArray(cidadeSelecionada)){
    if(cidadeSelecionada[0].label !== 'Todas Cidades'){
      const cidades = `CodigoIBGE=${cidadeSelecionada.map(cidade=> cidade.id).join('|')}`
      arrayQueryParams.push(cidades)
    }
  }
  if (estadoSelecionado[0] !== "Todos Estados"){
    const estado = `estado=${estadoSelecionado.join('|')}`
    arrayQueryParams.push(estado)
  }
  const queryParams = arrayQueryParams.join("&")
  return queryParams
  
  
}